import { useDispatch, useSelector } from "react-redux";
import { getCountry, postCountry } from "../../store/slices/Home/HomeSlice";
import * as Yup from "yup";
import { toast } from "react-toastify";

export const useContactForm = () => {
  const dispatch = useDispatch();
  const countryData = useSelector((state) => state.home);

  const getUserFlowData = () => {
    if (countryData?.countryStatus === "idle") {
      dispatch(getCountry());
    }
  };

  const phoneRegExp = /^(0*[1-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;
  const countryValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required."),
    phone: Yup.string()
      .matches(phoneRegExp, "Invalid phone number")
      .required("Phone number is required")
      .min(7, "Min 7 digits is required")
      .max(14, "Maximun 14 digits allowed"),
    name: Yup.string()
      .required("Name is required")
      .matches(/^[^\s].*/, "Name cannot start with a space")
      .matches(/^[^0-9]*$/, "Name cannot contain numbers"),
    country: Yup.string().required("Country is required"),
    message: Yup.string()
      .required("Message is required")
      .matches(/^[^\s].*/, "Message cannot start with a space"),
  });

  const countrySubmit = async (data, resetForm) => {
    // let dataCountry = data?.country_dial_code;

    const resultAction = await dispatch(postCountry(data));

    if (postCountry.fulfilled.match(resultAction)) {
      resetForm();
      toast.success("Form Submitted Successfully", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return {
    getUserFlowData,
    countryValidationSchema,
    countrySubmit,
  };
};
